import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import landscapeIndicatorService from '../services/landscape-indicator.service';
import { LandscapeIndicatorResponseDto } from '../dto/response/landscape-indicator-response.dto';
import { LandscapeIndicatorSaveRequestDto } from '../dto/request/landscape-indicator-save-request.dto';
import { LandscapeIndicatorUpdateRequestDto } from '../dto/request/landscape-indicator-update-request.dto';
import { LandscapeIndicatorDetailsResponseDto } from '../dto/response/landscape-indicator-details-response.dto';
// import { LandscapeIndicatorTranslateRequestDto } from '../dto/request/landscape-indicator-translate-request-dto';
import { LocalesLanguagesConstants } from '../../../../locales/locales';

const initialState = {
  status: 'idle',
  filteredStatus: 'idle',
  landscapeIndicators: [] as LandscapeIndicatorResponseDto[] | null,
  landscapeIndicator: {} as LandscapeIndicatorResponseDto | null,
  landscapeIndicatorDetails: {} as LandscapeIndicatorDetailsResponseDto | null,
  landscapeIndicatorsDetails: {} as
    | LandscapeIndicatorDetailsResponseDto[]
    | null,
  filteredLandscapeIndicatorsDetails: [] as
    | LandscapeIndicatorDetailsResponseDto[]
    | null,
  error: null as string | null,
};

// export const fetchLandscapeIndicators = createAsyncThunk(
//   'landscapeIndicators/fetchLandscapeIndicators',
//   async () => {
//     return await landscapeIndicatorService.fetchLandscapeIndicators();
//   }
// );

export const fetchLandscapeIndicatorById = createAsyncThunk(
  'landscapeIndicators/fetchLandscapeIndicatorById',
  async (params: { id: string; language: LocalesLanguagesConstants }) => {
    const { id, language } = params;
    return await landscapeIndicatorService.fetchLandscapeIndicatorById(
      id,
      language
    );
  }
);

export const fetchLandscapeIndicatorDetailsByProjectId = createAsyncThunk(
  'landscapeIndicators/fetchLandscapeIndicatorDetailsByProjectId',
  async (id: string) => {
    return await landscapeIndicatorService.fetchLandscapeIndicatorDetailsByProjectId(
      id
    );
  }
);

export const fetchLandscapeIndicatorDetailsByLandscapeId = createAsyncThunk(
  'landscapeIndicators/fetchLandscapeIndicatorDetailsByLandscapeId',
  async (id: string) => {
    return await landscapeIndicatorService.fetchLandscapeIndicatorDetailsByLandscapeId(
      id
    );
  }
);

// export const fetchLandscapeIndicatorByLandscapeId = createAsyncThunk(
//   'landscapeIndicators/fetchLandscapeIndicatorByLandscapeId',
//   async (landscapeId: string) => {
//     return await landscapeIndicatorService.fetchLandscapeIndicatorsByLandscapeId(
//       landscapeId
//     );
//   }
// );

export const fetchLandscapeIndicatorDetailsById = createAsyncThunk(
  'landscapeIndicators/fetchLandscapeIndicatorDetailsById',
  async (id: string) => {
    return await landscapeIndicatorService.fetchLandscapeIndicatorDetailsById(
      id
    );
  }
);

export const saveLandscapeIndicator = createAsyncThunk(
  'landscapeIndicators/saveLandscapeIndicator',
  async (saveRequest: LandscapeIndicatorSaveRequestDto) => {
    return await landscapeIndicatorService.saveLandscapeIndicator(saveRequest);
  }
);

export const updateLandscapeIndicator = createAsyncThunk(
  'landscapeIndicators/updateLandscapeIndicator',
  async (updateRequest: LandscapeIndicatorUpdateRequestDto) => {
    return await landscapeIndicatorService.updateLandscapeIndicator(
      updateRequest
    );
  }
);

export const deleteLandscapeIndicator = createAsyncThunk(
  'landscapeIndicators/deleteLandscapeIndicator',
  async (existingId: string) => {
    return await landscapeIndicatorService.deleteLandscapeIndicator(existingId);
  }
);

// export const translateLandscapeIndicator = createAsyncThunk(
//   'landscapeIndicators/translateLandscapeIndicator',
//   async (translateRequest: LandscapeIndicatorTranslateRequestDto) => {
//     return await landscapeIndicatorService.translateLandscapeIndicator(
//       translateRequest
//     );
//   }
// );

const landscapeIndicatorSlice = createSlice({
  name: 'landscapeIndicatorSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandscapeIndicatorById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLandscapeIndicatorById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.landscapeIndicator = action.payload;
      })
      .addCase(fetchLandscapeIndicatorById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      // .addCase(fetchLandscapeIndicators.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchLandscapeIndicators.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.landscapeIndicators = action.payload;
      // })
      // .addCase(fetchLandscapeIndicators.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })

      .addCase(fetchLandscapeIndicatorDetailsByProjectId.pending, (state) => {
        state.filteredStatus = 'loading';
      })
      .addCase(
        fetchLandscapeIndicatorDetailsByProjectId.fulfilled,
        (state, action) => {
          state.filteredStatus = 'succeeded';
          state.filteredLandscapeIndicatorsDetails = action.payload;
        }
      )
      .addCase(
        fetchLandscapeIndicatorDetailsByProjectId.rejected,
        (state, action) => {
          state.filteredStatus = 'failed';
          state.error = action.error?.message ?? null;
        }
      )

      .addCase(fetchLandscapeIndicatorDetailsByLandscapeId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchLandscapeIndicatorDetailsByLandscapeId.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.landscapeIndicatorsDetails = action.payload;
        }
      )
      .addCase(
        fetchLandscapeIndicatorDetailsByLandscapeId.rejected,
        (state, action) => {
          state.status = 'failed';
          state.error = action.error?.message ?? null;
        }
      )

      // .addCase(fetchLandscapeIndicatorByLandscapeId.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(
      //   fetchLandscapeIndicatorByLandscapeId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.landscapeIndicators = action.payload;
      //   }
      // )
      // .addCase(
      //   fetchLandscapeIndicatorByLandscapeId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )
      .addCase(fetchLandscapeIndicatorDetailsById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchLandscapeIndicatorDetailsById.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.landscapeIndicatorDetails = action.payload;
        }
      )
      .addCase(fetchLandscapeIndicatorDetailsById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(saveLandscapeIndicator.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveLandscapeIndicator.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.landscapeIndicators?.push(action.payload);
      })
      .addCase(saveLandscapeIndicator.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(updateLandscapeIndicator.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateLandscapeIndicator.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.landscapeIndicators) {
          const landscapeIndicatorIndex = state.landscapeIndicators.findIndex(
            (landscapeIndicator) => landscapeIndicator.id === action.payload.id
          );
          if (landscapeIndicatorIndex !== -1) {
            state.landscapeIndicators[landscapeIndicatorIndex] = action.payload;
          }
        }
      })
      .addCase(updateLandscapeIndicator.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(deleteLandscapeIndicator.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteLandscapeIndicator.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteLandscapeIndicator.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
    // .addCase(translateLandscapeIndicator.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(translateLandscapeIndicator.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    // })
    // .addCase(translateLandscapeIndicator.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    // });
  },
});

export default landscapeIndicatorSlice.reducer;
